import { render, staticRenderFns } from "./UiTooltip.vue?vue&type=template&id=6569e2e1"
import script from "./UiTooltip.vue?vue&type=script&lang=js"
export * from "./UiTooltip.vue?vue&type=script&lang=js"
import style0 from "./UiTooltip.vue?vue&type=style&index=0&id=6569e2e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports